import React, { useEffect } from "react";
import { STYLE_PREFIX } from "../../../../utils/const";
import Button from "../../../custom-antd/Button";
import "./style.less";
var PicAndTextModal = function PicAndTextModal(props) {
  var _messageInfo$extraSty5, _messageInfo$extraSty6, _messageInfo$extraSty7, _messageInfo$extraSty8, _messageInfo$extraSty9, _messageInfo$extraSty10, _messageInfo$extraSty11, _messageInfo$extraSty12;
  var messageInfo = props.messageInfo,
    cancel = props.cancel;
  var handleGoDetail = function handleGoDetail(id) {
    var _messageInfo$extraSty, _messageInfo$extraSty2;
    if ((_messageInfo$extraSty = messageInfo.extraStyle) !== null && _messageInfo$extraSty !== void 0 && (_messageInfo$extraSty2 = _messageInfo$extraSty.popupsConfig) !== null && _messageInfo$extraSty2 !== void 0 && _messageInfo$extraSty2.jumpUrl) {
      var _messageInfo$extraSty3, _messageInfo$extraSty4;
      window.open((_messageInfo$extraSty3 = messageInfo.extraStyle) === null || _messageInfo$extraSty3 === void 0 ? void 0 : (_messageInfo$extraSty4 = _messageInfo$extraSty3.popupsConfig) === null || _messageInfo$extraSty4 === void 0 ? void 0 : _messageInfo$extraSty4.jumpUrl);
    }
    cancel === null || cancel === void 0 ? void 0 : cancel(id);
  };
  useEffect(function () {
    document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.overflow = '';
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "message-modal-picText")
  }, /*#__PURE__*/React.createElement("div", {
    className: 'overlay'
  }), /*#__PURE__*/React.createElement("div", {
    className: 'popup'
  }, /*#__PURE__*/React.createElement("img", {
    src: (_messageInfo$extraSty5 = messageInfo.extraStyle) === null || _messageInfo$extraSty5 === void 0 ? void 0 : (_messageInfo$extraSty6 = _messageInfo$extraSty5.popupsConfig) === null || _messageInfo$extraSty6 === void 0 ? void 0 : _messageInfo$extraSty6.imageUrl,
    alt: "",
    className: 'img'
  }), /*#__PURE__*/React.createElement("div", {
    className: 'info'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'title'
  }, (_messageInfo$extraSty7 = messageInfo.extraStyle) === null || _messageInfo$extraSty7 === void 0 ? void 0 : (_messageInfo$extraSty8 = _messageInfo$extraSty7.popupsConfig) === null || _messageInfo$extraSty8 === void 0 ? void 0 : _messageInfo$extraSty8.title), /*#__PURE__*/React.createElement("div", {
    className: 'content'
  }, (_messageInfo$extraSty9 = messageInfo.extraStyle) === null || _messageInfo$extraSty9 === void 0 ? void 0 : (_messageInfo$extraSty10 = _messageInfo$extraSty9.popupsConfig) === null || _messageInfo$extraSty10 === void 0 ? void 0 : _messageInfo$extraSty10.text), /*#__PURE__*/React.createElement("div", {
    className: 'footer'
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      cancel === null || cancel === void 0 ? void 0 : cancel(messageInfo.id);
    }
  }, "\u53D6\u6D88"), (_messageInfo$extraSty11 = messageInfo.extraStyle) !== null && _messageInfo$extraSty11 !== void 0 && (_messageInfo$extraSty12 = _messageInfo$extraSty11.popupsConfig) !== null && _messageInfo$extraSty12 !== void 0 && _messageInfo$extraSty12.jumpUrl ? /*#__PURE__*/React.createElement(Button, {
    type: 'primary',
    onClick: function onClick() {
      return handleGoDetail(messageInfo.id);
    }
  }, "\u67E5\u770B\u8BE6\u60C5") : null))));
};
export default PicAndTextModal;